import React, { useContext } from 'react'
import './Filter.scss'
import { FilterContext } from '../../context/filterContext'


const Filter = () => {
    const { filters, handleChange, filValues, handleAllChange, checkAll } = useContext(FilterContext)
    

    const filterItems = filters.map(({ id, name}) => {
        const isChecked = filValues.includes(id)
        return (
            <label key={id} className="b-contain">
                <span>{name}</span>
                <input type="checkbox" checked={isChecked} onChange={(e)=>handleChange(id, e.target.checked)}/>
                <div className="b-input"></div>
            </label>
        )
    })

    return (
        <div className='filter'>
            <div className='filter-title'>Количество пересадок</div>
            <label  className="b-contain">
                <span>Все</span>
                <input type="checkbox" checked={checkAll} onChange={(e)=>handleAllChange( e.target.checked)}/>
                <div className="b-input"></div>
            </label>
           {filterItems}
        </div>
    )
}

export default Filter
